import { useEffect, useState } from "react";
import { ORIGINAL_COVERS } from "./originalCovers";

const KEY = "marsilya-recent";
const MAX = 18;
const EVENT = "marsilya-recent";

const ORIGINALS = {
  aviator: { id: "aviator", path: "/oyun/aviator", banner: ORIGINAL_COVERS.aviator, name: "Aviator" },
  zar: { id: "zar", path: "/oyun/zar", banner: ORIGINAL_COVERS.zar, name: "Zar" },
  dice: { id: "zar", path: "/oyun/zar", banner: ORIGINAL_COVERS.dice, name: "Zar" },
  mayin: { id: "mayin", path: "/oyun/mayin", banner: ORIGINAL_COVERS.mayin, name: "Mayın" },
  mines: { id: "mayin", path: "/oyun/mayin", banner: ORIGINAL_COVERS.mines, name: "Mayın" },
  plinko: { id: "plinko", path: "/oyun/plinko", banner: ORIGINAL_COVERS.plinko, name: "Plinko" },
  limbo: { id: "limbo", path: "/oyun/limbo", banner: ORIGINAL_COVERS.limbo, name: "Limbo" },
  cark: { id: "cark", path: "/oyun/cark", banner: ORIGINAL_COVERS.cark, name: "Çark" },
  wheel: { id: "cark", path: "/oyun/cark", banner: ORIGINAL_COVERS.wheel, name: "Çark" },
  rulet: { id: "rulet", path: "/oyun/rulet", banner: "", name: "Rulet" },
  blackjack: { id: "blackjack", path: "/oyun/blackjack", banner: ORIGINAL_COVERS.blackjack, name: "Blackjack" },
};

const fold = (value = "") => String(value).toLowerCase().replace(/^local-/, "").trim();

const safeBanner = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/drakon|gator\./i.test(raw) || /^https?:\/\//i.test(raw) || raw.startsWith("//")) return "";
  if (raw.startsWith("/")) return raw;
  return "";
};

const compact = (game = {}) => {
  const rawId = fold(game.game_id || game.slug || "");
  const fromPath = fold(String(game.path || "").split("/").pop());
  const orig = ORIGINALS[rawId] || ORIGINALS[fromPath] || null;
  if (!rawId && !orig) return null;
  const id = orig?.id || rawId;
  const local = Boolean(game.local || game.path || orig);
  return {
    game_id: id,
    game_code: local ? `local-${id}` : game.game_code || "",
    game_name: orig?.name || game.game_name || game.title || id,
    provider_game: game.provider_game || (local ? "Marsilya Orijinal" : ""),
    local,
    path: orig?.path || game.path || "",
    banner: safeBanner(orig?.banner || game.banner || ""),
  };
};

const unique = (items) => {
  const seen = new Set();
  return items.filter((item) => {
    const key = item.path || item.game_id;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export function loadRecent() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (!Array.isArray(raw)) return [];
    return unique(raw.map(compact).filter(Boolean)).slice(0, MAX);
  } catch {
    return [];
  }
}

export function rememberGame(game) {
  const item = compact(game);
  if (!item) return loadRecent();
  const key = item.path || item.game_id;
  const next = unique([item, ...loadRecent().filter((row) => (row.path || row.game_id) !== key)]).slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event(EVENT));
  return next;
}

export function forgetGame(game) {
  const item = compact(game) || {};
  const key = item.path || item.game_id || game?.path || game?.game_id;
  if (!key) return loadRecent();
  const next = loadRecent().filter((row) => (row.path || row.game_id) !== key);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event(EVENT));
  return next;
}

export function useRecentGames() {
  const [items, setItems] = useState(() => loadRecent());
  useEffect(() => {
    const cleaned = loadRecent();
    localStorage.setItem(KEY, JSON.stringify(cleaned));
    setItems(cleaned);
    const sync = () => setItems(loadRecent());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return items;
}
